<template>
  <section class="profile-options">
    <h2 class="title h4">
      {{ title }}
    </h2>
    <div class="body">
      <div class="action-btn">
        <GoogleLoginButton
          :form-type="formType"
          :button-text="buttonTexts.google"
          :data-event="['signup', 'login'].includes(tracking) ? 'google.click' : 'sign_up_form_google.click'"
          terms-agreed
          data-async-event
          data-direct-send
          :resources="resources"
        />
      </div>
      <div class="action-btn">
        <FacebookLoginButton
          :form-type="formType"
          :button-text="buttonTexts.facebook"
          :data-event="['signup', 'login'].includes(tracking) ? 'facebook.click' : 'sign_up_form_facebook.click'"
          terms-agreed
          data-async-event
          data-direct-send
          :resources="resources"
        />
      </div>
      <div class="action-btn">
        <LinkedinLoginButton
          :form-type="formType"
          :button-text="buttonTexts.linkedin"
          :data-event="['signup', 'login'].includes(tracking) ? 'linkedin.click' : 'sign_up_form_linkedin.click'"
          terms-agreed
          data-async-event
          data-direct-send
          :resources="resources"
        />
      </div>
      <div class="action-btn">
        <button @click="$emit('next-step')">
          <IconMail /> Continue with email
        </button>
      </div>
    </div>

    <div class="terms">
      By continuing, you agree to {{ $config.platformName }}’s
      <a target="_blank" :href="`${$config.siteUrl}/terms-of-use/`">Terms of Use</a>
      and
      <a target="_blank" :href="`${$config.siteUrl}/privacy-policy/`">Privacy Policy</a>
    </div>

    <slot class="footer-test" name="footer" />
  </section>
</template>

<script>
import IconMail from '@itbpbg/lms-components/src/assets/svg/icon-mail.svg?vue-component';
import GoogleLoginButton from '../GoogleLoginButton';
import FacebookLoginButton from '../FacebookLoginButton';
import LinkedinLoginButton from '../LinkedinLoginButton';

export default {
  components: {
    GoogleLoginButton,
    FacebookLoginButton,
    LinkedinLoginButton,
    IconMail,
  },
  props: {
    title: { type: String, required: true },
    type: { type: String, default: '' },
    tracking: { type: String, default: '' },
    resources: Boolean,
  },
  data() {
    return {
      formType: this.type || this.$route.name,
      buttonTexts: {
        google: 'Continue with Google',
        facebook: 'Continue with Facebook',
        linkedin: 'Continue with LinkedIn',
      },
    };
  },
};
</script>

<style lang="scss">
.profile-options {
  .title {
    text-align: center;
    margin-bottom: var(--spacing-28);
  }

  .body {
    margin-bottom: var(--spacing-32);

    .action-btn {
      border: 1px solid rgba(0, 12, 31, 0.18);
      border-radius: 5px;

      &:not(:last-child) {
        margin-bottom: var(--spacing-12);
      }

      &:hover {
        background-color: var(--main-light-shade-1);
        border: 1px solid var(--main-dark-opacity-12);
      }

      > button {
        border: none;
        background: none;
        padding: 0;
        margin: 0;
        width: 100%;
        font-size: 100%;
        font-family: inherit;
        line-height: normal;
        cursor: pointer;

        > svg {
          width: 24px;
          padding-left: 2px;
          padding-right: 2px;

          > path[stroke] {
            stroke: var(--main-dark-light-3);
          }
        }
      }

      > a,
      a.visible,
      button {
        display: flex;
        align-items: center;
        padding: var(--spacing-14) var(--spacing-44);
        line-height: unset;
        font-size: 18px;

        > svg {
          margin-right: 15px;
          width: 24px;
        }
      }

      .invisible {
        overflow: hidden;
      }
    }
  }

  .terms {
    font-size: 14px;
    color: rgba(0, 12, 31, 0.48);
    font-weight: 500;
    line-height: 130%;
    margin-bottom: var(--spacing-24);
  }

  .footer {
    color: rgba(0, 12, 31, 0.48);
    text-align: center;
    line-height: 150%;
  }
}

@include bp($bp-laptop) {
  .profile-options {
    .body {
      .action-btn {
        > a,
        a.visible,
        button {
          padding: var(--spacing-14) var(--spacing-24);
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .profile-options {
    .body {
      .action-btn {
        > a,
        a.visible,
        button {
          padding-right: var(--spacing-24);
          font-size: 16px;

          svg {
            flex-shrink: 0;
          }
        }
      }
    }
  }
}
</style>
